'use es6';

import { createTracker } from 'usage-tracker';
import events from 'DesignManagerIde/events.yaml';
const tracker = createTracker({
  events,
  properties: {
    namespace: 'design-manager-ide'
  },
  lastKnownEventProperties: ['screen', 'subscreen']
});
export default tracker;